import styled, { css } from 'styled-components';
import { makeStyles, createStyles, MuiTheme, color } from '@kis-technologies/kis-ui';

interface ScrollFlexProps {
  hasScroll?: boolean;
}

export const ScrollFlex = styled.div<ScrollFlexProps>`
  overflow-y: auto;
  max-height: 100%;
  flex: 0 1 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  background: ${color.WHITE} no-repeat;
  background-position:
    0 0,
    0 100%;
  background-size: 100% 14px;

  ${(props) =>
    props.hasScroll
      ? css`
          padding: 0 61px 0 0;
        `
      : css`
          padding: 0;
        `};

  > div {
    margin: 0;
  }

  /* Scrollbar Styling */
  ::-webkit-scrollbar {
    width: 43px;
    background: transparent;
  }

  ::-webkit-scrollbar-track {
    background-color: ${color.LIGHT_GRAY};
    border-radius: 25px;
    margin: 82px 0;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 23px;
    background: #000;
    background: linear-gradient(-45deg, ${color.BLACK}, ${color.BLACK}, ${color.GRAY});
  }
`;

export const useStyles = (props: { hasScroll: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      scrollbarFlex: {
        padding: props.hasScroll ? '0px 24px 0px 0px' : '0px',
        [theme.breakpoints.down('lg')]: {
          padding: props.hasScroll ? '0px 8px 0px 0px' : '0px'
        },
        [theme.breakpoints.only('lg')]: {
          padding: props.hasScroll ? '0px 20px 0px 0px' : '0px'
        }
      }
    })
  );
